import { INJECT_RECOMMENDED_POSTS } from './recommendedPosts.actions'
import { getRecommendedPosts } from '../../../jsCore/application/pageDataObject'

const INITIAL_STATE = {
  posts: getRecommendedPosts(),
}

export function recommendedPostsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case INJECT_RECOMMENDED_POSTS:
      return { ...state, ...action.state }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/recommendedPosts/recommendedPosts.reducers.js